<template>
  <v-main class="text-center" id="payment" style="min-height: 100vh">
    <v-sheet id="payment-card">
      <v-container style="max-width: 1280px">
        <v-row justify="center">
          <v-col cols="12" lg="8">
            <v-card>
              <v-card-text class="black--text">
                <v-container>
                  <v-row justify="center">
                    <v-col>
                      <h6 class="text-h6">
                        Thank You
                      </h6>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <p class="text-body-1 mb-0">
                        We at My Life Pie have a simple rule:<br>
                        <span class="blue--text">Treat others the way you want to be treated.</span><br>
                        Be honest if you found this tool helpful, please pay $2 so we can help more people. 
                      </p>
                    </v-col>
                  </v-row>
                  <v-row justify="center">
                    <v-col>
                      <stripe-checkout
                        ref="checkoutRef"
                        mode="payment"
                        :pk="publishableKey"
                        :line-items="lineItems"
                        :success-url="successURL"
                        :cancel-url="cancelURL"
                        @loading="v => loading = v"
                      />
                      <v-btn color="primary" @click="submit" block rounded large>
                        Pay Now
                        <v-icon right>
                          mdi-chart-pie
                        </v-icon>
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-sheet>

    <v-sheet id="idk">
      <v-container style="max-width: 1280px">
        <v-row justify="center">
          <v-col cols="12" lg="8">
            <v-card>
              <v-card-text class="black--text">
                <h6 class="text-h6 mb-0">
                  Feedback
                </h6>
                <p class="text-subtitle-1">
                  If you found this tool helpful, we are thrilled. Please share with us the key benefits.<br>
                  If you have ideas to improve this tool please share them. Help us to help others.<br>
                  If you had technical issues, we apologize. Please share them.
                </p>
                <v-row>
                  <v-col cols="12" lg="12">
                    <v-text-field label="Name (Optional)"></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" lg="12">
                    <v-text-field label="Email (Optional)"></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <v-textarea label="Message"></v-textarea>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <v-btn class="mb-5" color="success" block rounded large @click="submitted = true" :disabled="submitted">
                      Submit
                      <v-icon right>
                        mdi-message
                      </v-icon>
                    </v-btn>
                    <small class="text-caption">
                      If you experienced any technical difficulties, please consider leaving your email so we can follow up with a future update.
                    </small>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-sheet>
  </v-main>
</template>

<script>
import { StripeCheckout } from '@vue-stripe/vue-stripe';
export default {
  components: {
    StripeCheckout,
  },
  data () {
    this.publishableKey = "pk_live_51J892fDy6ozJcsSrk0XkRBPHXjtgtNmuh35Q6UBSh35vkhLVrF0MalTdKEY42uAYMialPln0ZLFtuZxP2Jrm2WUr00MOMiY2V4";
    return {
      submitted: false,
      loading: false,
      lineItems: [
        {
          price: 'price_1JBOB1Dy6ozJcsSr2LhdD2bq', // The id of the one-time price you created in your Stripe dashboard
          quantity: 1,
        },
      ],
      successURL: 'http://mylifepie.com/paymentsuccess',
      cancelURL: 'http://mylifepie.com/',
    };
  },
  methods: {
    submit () {
      // You will be redirected to Stripe's secure checkout page
      this.$refs.checkoutRef.redirectToCheckout();
    },
  },
};
</script>